import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewChecked, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { TimeApiService } from 'cbc-shared-lib';
import { Sgke302aResponseSearchResultList } from 'sg-api';


@Component({
  selector: 'sgke300d-search-result',
  templateUrl: './sgke300d-search-result.component.html',
  styleUrls: ['./sgke300d-search-result.component.scss']
})
export class Sgke300dSearchResultComponent implements OnInit, OnDestroy, AfterViewChecked {
  /** 検索結果データ */
  @Input() searchResultList: Array<Sgke302aResponseSearchResultList>;

  /** 登録ボタン押下イベント */
  @Output() onDblClickRowEvent = new EventEmitter();

  /** データソース */
  dataSource: MatTableDataSource<Sgke302aResponseSearchResultList>;

  /** ソート */
  @ViewChild('sort1', { static: true }) sort: MatSort;
  /** ページングインスタンス */
  @ViewChild('paginator1', { static: true }) paginator: MatPaginator;

  /** テーブル表示カラム */
  displayedColumnsCol: string[] = [
    'claimYmt',
    'payDlineYearmonthdate',
    'payCtrNo',
    'visitName',
    'supplystopBreakscheduleAchievymd',
    'totalsummaryAname',
    'nrcptMny',
    'pressmanagementdivisionAname',
    'companyAname',
    'areaAname',
    'koufuYearmonthdate',
    'pressmanagementdivisionKirikaersnAname',
    'pressStsAname',
    'effectCtrUmu',
    'chargedivisionAname',
  ];

  /** 選択した行の情報 */
  selection: SelectionModel<Sgke302aResponseSearchResultList> = new SelectionModel<Sgke302aResponseSearchResultList>(false, []);

  /**
   * コンストラクタ
   * @param timeApiService TimeApiService
   */
  constructor(
    public timeApiService: TimeApiService,
  ) {
  }

  /**
   * コンポーネント初期化処理
   */
  ngOnInit(): void {
    // Table表示データ作成
    this.dataSource = new MatTableDataSource<Sgke302aResponseSearchResultList>(this.searchResultList);
  }

  /**
   * コンポーネント終了処理
   */
  ngOnDestroy(): void {
  }

  /**
   * View変更時実施処理
   */
  ngAfterViewChecked() {
    // 表データと、ソート/ページングを連携
    this.dataSource.sort ??= this.sort;
    this.dataSource.paginator ??= this.paginator;
  }

  /**
   * 行ダブルクリック時処理
   * @param row ダブルクリックした行の内容
   */
  onDblClickRow(row) {
    this.onDblClickRowEvent.emit(row);
  }
}
